const initState = {
  resolutions: [],
  resolutionchats: [],
  singleResolution: [],
  isLoading: false,
};

const resolutionCenterReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_RESOLUTION":
      return {
        ...state,
        resolutions: action.payload,
      };
    case "GET_RESOLUTION_CHAT":
      return {
        ...state,
        resolutionchats: action.payload,
      };
    case "GET_SINGLE_RESOLUTION":
      return {
        ...state,
        singleResolution: action.payload,
      };
      case "SET_IS_LOADINGS":
        return {
          ...state,
          isLoading: action.payload,
        };
    default:
      return {
        ...state,
      };
  }
};
export default resolutionCenterReducer;
